import { doc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase/firebaseConfig';

/**
 * 🔔 Actualizar metadata de la familia cuando hay cambios
 * 
 * Llamar esta función cuando el admin:
 * - Agrega/elimina/edita members
 * - Agrega/elimina/edita checklists  
 * - Agrega/elimina/edita activities
 * 
 * Esto permite que el sistema de cache detecte cambios
 * sin necesidad de listeners en tiempo real
 */
export async function updateFamilyMetadata(familyId: string): Promise<void> {
  try {
    const familyRef = doc(db, 'families', familyId);
    
    await updateDoc(familyRef, {
      lastModified: serverTimestamp()
    });
    
    console.log('✅ Family metadata updated');
  } catch (error) {
    console.error('Error updating family metadata:', error);
    // No throw - esto es non-critical
  }
}

/**
 * Helper: Envolver función que hace cambios con actualización de metadata
 */
export function withMetadataUpdate<T extends any[], R>(
  fn: (...args: T) => Promise<R>,
  familyId: string
): (...args: T) => Promise<R> {
  return async (...args: T): Promise<R> => {
    const result = await fn(...args);
    await updateFamilyMetadata(familyId);
    return result;
  };
}
